import { forwardRef } from 'react';
import { Theme } from 'app/shared/utils';
import { TextInputStyled } from './style';

const TextInput = forwardRef(({ label, id, type = 'text', ...props }, ref) => {
  return (
    <TextInputStyled
      style={{ marginLeft: 0, fontSize: '16px', fontFamily: 'Roboto' }}
      variant="outlined"
      fullWidth
      color={Theme.colors.black}
      label={label}
      id={id}
      type={type}
      inputRef={ref}
      {...props}
    />
  );
});

TextInput.displayName = 'TextInput';

export default TextInput;
